import * as yup from 'yup';

const validationMessage = {
  email: () => `Please enter a valid email`,
  nameReg: () => `Only letters, number and underscores are allowed`,
  required: (name) => `${name} is a required field.`,
};

export const CreateProjectModalValidations = (isCreationGroupView) => {
  if (isCreationGroupView) {
    return yup.object().shape({
      projectName: yup.string().required(validationMessage.required('Project Name')),

      projectLead: yup.string().required(validationMessage.required('Project Lead')), // Ensure this is enforced

      schedule: yup
        .array()
        .of(
          yup.object().shape({
            value: yup.string(),
          }),
        )
        .nullable(),
    });
  }
  return yup.object().shape({
    projectName: yup.string().required(validationMessage.required('Project Name')),
    client: yup.string().required(validationMessage.required('Client')),
    state: yup.string().required(validationMessage.required('State')),
    start: yup.string().required(validationMessage.required('start')),
    isNonBillable: yup.boolean().required(),
    probability: yup.string().when('isNonBillable', (isNonBillable = false, schema) => {
      return isNonBillable
        ? schema.nullable()
        : schema.required(validationMessage.required('Probability'));
    }),
    projectLead: yup.string().required(validationMessage.required('Project Lead')), // Ensure this is enforced

    schedule: yup
      .array()
      .of(
        yup.object().shape({
          value: yup.string(),
        }),
      )
      .nullable(),
  });
};

export const exportCsvModalValidations = () => {
  return yup.object().shape({
    type: yup.string().required(validationMessage.required('Export Type')),
    range: yup.array().required(validationMessage.required('Date Range')),
  });
};

export const CreateContactValidations = () => {
  return yup.object().shape({
    firstName: yup.string().required(validationMessage.required('First Name')),
    lastName: yup.string().required(validationMessage.required('Last Name')),
    title: yup.string().required(validationMessage.required('Title')),

    companyID: yup.string().required(validationMessage.required('Company')),
    type: yup.string().required(validationMessage.required('Type')),

    contactState: yup.string().required(validationMessage.required('State')),

    emailAddress: yup
      .string()
      .trim()
      .required(validationMessage.required('Email'))
      .email(validationMessage.email()),

    phoneNumber: yup
      .string()
      .trim()
      .required(validationMessage.required('Phone Number'))
      .matches(/^\d+$/, 'Phone numbers must only contain numbers.')
      .min(10, 'Phone numbers must be at least 10 digits.'),
  });
};

export const CreateCompanyValidations = () => {
  return yup.object().shape({
    companyName: yup.string().required(validationMessage.required('Company Name')),
    type: yup.string().required(validationMessage.required('Type')),
    companyState: yup.string().required(validationMessage.required('Company State')),
    streetAddress: yup.string().required(validationMessage.required('Street Address')),
    city: yup.string().required(validationMessage.required('City')),
    province: yup.string().required(validationMessage.required('Province')),
    country: yup.string().required(validationMessage.required('Country')),
    postalCode: yup.string().required(validationMessage.required('Postal Code')),
    webAddress: yup.string().required(validationMessage.required('Web Address')),
    phoneNumber: yup
      .string()
      .trim()
      .required(validationMessage.required('Phone Number'))
      .matches(/^\d+$/, 'Phone numbers must only contain numbers.')
      .min(10, 'Phone numbers must be at least 10 digits.'),

    // This field is used to conditionally validate the billing fields.
    isNotBilling: yup.boolean(),

    billingStreetAddress: yup.string().when('isNotBilling', {
      is: false,
      then: () => yup.string().required(validationMessage.required('Billing Address Line One')),
      otherwise: () => yup.string(),
    }),
    billingAddress: yup.string(), // optional field
    billingCity: yup.string().when('isNotBilling', {
      is: false,
      then: () => yup.string().required(validationMessage.required('Billing City')),
      otherwise: () => yup.string(),
    }),
    billingProvince: yup.string().when('isNotBilling', {
      is: false,
      then: () => yup.string().required(validationMessage.required('Billing Province/State')),
      otherwise: () => yup.string(),
    }),
    billingPostalCode: yup.string().when('isNotBilling', {
      is: false,
      then: () => yup.string().required(validationMessage.required('Billing Postal/Zip')),
      otherwise: () => yup.string(),
    }),
    billingCountry: yup.string().when('isNotBilling', {
      is: false,
      then: () => yup.string().required(validationMessage.required('Billing Country')),
      otherwise: () => yup.string(),
    }),
  });
};

export const CreateUserValidations = () => {
  return yup.object().shape({
    firstName: yup.string().required(validationMessage.required('First Name')),
    surname: yup.string().required(validationMessage.required('Surname')),
    email: yup
      .string()
      .required(validationMessage.required('Email'))
      .email(validationMessage.email()),
    role: yup.string().required(validationMessage.required('Role')),
    serviceGroup: yup.string().required(validationMessage.required('Service Group')),
    permissions: yup.string().required(validationMessage.required('Permissions')),
    employmentStatus: yup.string().required(validationMessage.required('Employment Status')),
    rate: yup
      .string()
      .required(validationMessage.required('Rate'))
      .matches(/^\d+(\.\d{1,2})?$/, 'Rate must be a valid number.'),
    cost: yup
      .string()
      .required(validationMessage.required('Cost'))
      .matches(/^\d+(\.\d{1,2})?$/, 'Cost must be a valid number.'),
    title: yup.string().required(validationMessage.required('Title')),
  });
};
